import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Heading } from '@fiverr-private/typography';
import type { Currency } from '@fiverr-private/currencies_plugin';
import { AttachmentsGallery } from '../Shared/AttachmentsGallery';
import { GeneratedContent } from '../Shared/GeneratedContent';
import { BudgetAndTimeline } from '../Shared/BudgetAndTimeline/BudgetAndTimeline';
import type BuyerBriefResponse from '../../types/BuyerBriefResponse';
import { BriefStatus } from '../Shared/BriefStatus';
import { ServiceOptions } from '../Shared/ServiceOptions';

interface BuyerBriefOverviewProps extends BuyerBriefResponse {
  currency?: Currency;
}

export const BuyerBriefOverview: React.FC<BuyerBriefOverviewProps> = ({
  title,
  attachments,
  content,
  pricingType,
  budgetInCents,
  deliveryDate,
  timeline,
  status,
  currency,
  metadataAnswers,
  nestedSubCategoryId,
  subCategoryId,
}) => (
  <Stack direction="column" gap="6" padding="2">
    <Stack direction="column" gap="8">
      <BriefStatus status={status} />
      <Heading size="h_sm">{title}</Heading>
      <GeneratedContent generatedContent={content.generatedContent} />
      <ServiceOptions
        metadataAnswers={metadataAnswers}
        nestedSubCategoryId={nestedSubCategoryId}
        subCategoryId={subCategoryId}
      />
      <BudgetAndTimeline
        timeline={timeline}
        pricingType={pricingType}
        budgetInCents={budgetInCents}
        deliveryDate={deliveryDate}
        currency={currency}
      />
      <AttachmentsGallery attachments={attachments} />
    </Stack>
  </Stack>
);
